export default __webpack_public_path__ + "static/media/logo.590fec81.svg";